





































































	import { Component, Ref, Mixins, Vue } from 'vue-property-decorator';
	import { AppUserData, AppUserTokens } from '@/types/AppUser';
	import { BContainer, BForm, BRow, BCol, BImg, BCard, BCardBody, BFormGroup, BFormInput, BButton, BFormInvalidFeedback } from 'bootstrap-vue';
	import * as Msal from 'msal';
	import Configuration from '@/types/Configuration';
	import InlineSvg from 'vue-inline-svg';
	import ToasterMixin from '@/mixins/ToasterMixin';
	import AxiosService from '@/services/axiosService';
    import CookieConsent from '@/components/CookieConsent.vue'

	@Component({
		components: {
			'b-container': BContainer,
			'b-form': BForm,
			'b-row': BRow,
			'b-col': BCol,
			'b-img': BImg,
			'b-card': BCard,
			'b-card-body': BCardBody,
			'b-form-group': BFormGroup,
			'b-form-input': BFormInput,
			'b-form-invalid-feedback': BFormInvalidFeedback,
			'b-btn': BButton,
			'inline-svg': InlineSvg,
			'CookieConsent': CookieConsent
		}
	})
	export default class LoginBox extends Mixins(ToasterMixin) {
		@Ref('btnLoginToAzure') readonly btnLoginToAzure!: BButton;

		isBusyAzure = false;
		errors = [] as string[];

		get isAuthenticatedAzure() {
			if (this.$store.state.authType == Configuration.AzureAuthType) {
				return this.isAzureAuthenticated();
			}
			return false;
		}

		get isAuthenticated() {
			if (this.$store.state.authType == Configuration.AzureAuthType) {
				return this.isAzureAuthenticated();
			}
			else {
				return this.isTRAuthenticated();
			}
		}

		get showCookieConsent() {
            return this.$store.state.cookieConsent != null ? !this.$store.state.cookieConsent : true;
		}

		mounted() {
			this.$msal.options.callbacks = {
				onAuthentication: (ctx: object, error: Msal.AuthError, response: Msal.AuthResponse | undefined) => {
					if (response) {
						return;
					}
					console.log(error);
				},
				onToken: (ctx: object, error: Msal.AuthError | null, response: Msal.AuthResponse | null) => {
					if (response) {
						this.addTokenToStore(response.accessToken);
						this.getLoggedInUserAndRedirect('Bearer ' + response.accessToken);
						return;
					}
					if (error) {
                        sessionStorage.clear();
						this.deleteAllCookies();
						window.location.reload();
                    }
					console.log(error);
				},
				onBeforeSignOut: () => {
					return;
				}
			};
		}

		onCookieApproved(approved: boolean) {
            this.$store.dispatch('setCookieConsent', approved);
        }

		loginToAzure() {
			if (this.isBusyAzure) return;

			this.isBusyAzure = true;

			this.addAuthTypeToStore(Configuration.AzureAuthType);
			this.addTokensToStore(null);
			this.$msal.signIn();
		}

		deleteAllCookies() {
			const cookies = document.cookie.split(";");

			for (let i = 0; i < cookies.length; i++) {
				const cookie = cookies[i];
				const eqPos = cookie.indexOf("=");
				const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
				document.cookie = name + "=;expires=" + new Date().toUTCString() + ";path=/";
			}
		}

		isAzureAuthenticated() {
			return this.$msal.isAuthenticated();
		}

		isTRAuthenticated() {
			if (this.$appUser != null) return true;
			if (Vue.prototype.$appUser != null) return true;
			if (this.$store.getters.appUser != null) return true;

			return false;
		}

		async getLoggedInUserAndRedirect(apiAccessToken: string) {
            try {
                const response = await AxiosService.request<AppUserData>({
                    url: `authentication/loggedinuser`,
					method: 'GET',
                    headers: {
						Authorization: apiAccessToken
					}
                });

                this.addAppUserToStore(response.data);
				this.$appUser = response.data;
				Vue.prototype.$appUser = response.data;
				this.redirectToReturnUrl();
            }
			catch (error) {
				//this.handleErrors(error);
            }
			finally {
                this.$store.dispatch('setCookieConsent', true);
				this.isBusyAzure = false;
            }
		}

		redirectToReturnUrl() {
			if (this.$router.currentRoute.query.returnUrl) {
				this.$router.push({ path: this.$router.currentRoute.query.returnUrl as string });
			}
			else {
				this.$router.push('/');
			}
		}

		getApiAccessToken() {
			return this.$store.state.apiAccessToken;
		}

		logoutFromAzure() {
			this.clearStore();
			this.$msal.signOut();
		}

		logout() {
			if (this.isAuthenticatedAzure) {
				this.logoutFromAzure();
			}
		}

		clearStore() {
			this.$store.dispatch('setApiAccessToken', '');
			this.$store.dispatch('setApiRefreshToken', '');
			this.$store.dispatch('setAppUser', null);
			this.$store.dispatch('setAuthType', '');
			this.$appUser = null;
			Vue.prototype.$appUser = null;
		}

		private addTokenToStore(token: string) {
			this.$store.dispatch('setApiAccessToken', token);
		}

		private addTokensToStore(tokens: AppUserTokens | null) {
			const accessToken = tokens?.accessToken || '';
			const refreshToken = tokens?.refreshToken || '';

			this.$store.dispatch('setApiAccessToken', accessToken);
			this.$store.dispatch('setApiRefreshToken', refreshToken);
		}

		private addAppUserToStore(appUser: AppUserData) {
			this.$store.dispatch('setAppUser', appUser);
		}

		private addAuthTypeToStore(authType: string) {
			this.$store.dispatch('setAuthType', authType);
		}


	}
